import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Route } from 'app/enums';
import logo from 'assets/images/logo-icon.svg';
import { MATCH_ID_QUERY_KEY } from 'app/constants';
import { MatchModalCountdown } from 'modules/matches/components/MatchModalCountdown';
import { currentMatchSelector } from 'modules/matches/store/current-match/selectors';
import moment from 'moment/moment';
import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ShareButton } from 'shared/components/ShareButton';
import { useStyles } from './MatchModalHeader.styles';

interface MatchModalHeaderProps {
  title: string;
  matchId: string;
  createdAt: string;
}

const TIME_TOOLTIP = 'The players should join the match before the expiration in';

export const MatchModalHeader: FC<MatchModalHeaderProps> = ({ title, matchId, createdAt }) => {
  const theme = useTheme();
  const { classes } = useStyles();
  const isFullScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const expirationTime = useSelector(currentMatchSelector.expirationTime);
  const expirationDate = useMemo(
    () => moment(createdAt).add(expirationTime, 'seconds').toISOString(),
    [createdAt, expirationTime]
  );

  const link = useMemo(
    () => `${window.location.origin}${Route.Home}?${MATCH_ID_QUERY_KEY}=${matchId}`,
    [matchId]
  );

  if (!title) {
    return null;
  }

  return (
    <Box className={classes.root}>
      <Box>
        <Box className={classes.header}>
          <Box className={classes.headerIcon}>
            <img src={logo} alt="okletsplay-logo" />
          </Box>
          <Typography component="div" variant="h6">
            {title}
          </Typography>
        </Box>
        {!isFullScreen && <MatchModalCountdown date={expirationDate} tooltip={TIME_TOOLTIP} />}
      </Box>
      {isFullScreen && <MatchModalCountdown date={expirationDate} tooltip={TIME_TOOLTIP} />}
      <ShareButton link={link} />
    </Box>
  );
};
